import store from '@/store/store'

export default function auth({next, router}) {

	if (store.getters['auth/authenticated']) {
		store.dispatch('userStore/attemptGetUser');
	} else {
		return next({
			name: 'page-login'
		})
	}

	return next();
}
